import { ThemeProvider } from '@material-ui/core/styles';
import React, { useContext, useState } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Home from './pages/Home';
import LateralDrawer from './ui/LateralDrawer/LateralDrawer';
import { LanguageProvider } from './Language/LanguageProvider';
import { ThemeContext, ThemeContextProvider } from './ui/themes/ThemeContext';
import MyWork from './pages/MyWork';
import Contact from './pages/Contact';

function App() {
  const { theme } = useContext(ThemeContext);

  return (
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <BrowserRouter>
          <LateralDrawer />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/mywork" component={MyWork} />
            <Route exact path="/contact" component={Contact} />

            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
